const pageChangeEvents = {
    onPageHide(pageKey){
        let scrollPositions = {};
        // create object with urls and positions
        if (localStorage.getItem('scrollPositions')) {
            scrollPositions = JSON.parse(localStorage.getItem('scrollPositions'));
        }
        scrollPositions[pageKey] = {scrollY: window.scrollY};
        let scrollPositionsObject = Object.assign({}, scrollPositions);
        localStorage.setItem("scrollPositions", JSON.stringify(scrollPositionsObject));
    },
    onPageShow(pageKey){
        // create object with urls and positions
        let scrollPositionsJson = localStorage.getItem('scrollPositions');
        if (scrollPositionsJson) {
            let scrollPositions = JSON.parse(scrollPositionsJson);
            if (scrollPositions[pageKey] && !isNaN(scrollPositions[pageKey])) {
                window.scrollTo(0, scrollPositions[pageKey]);
            }
        }
    }
}
export { pageChangeEvents as default };
